export const CANCELLATION_POLICY_CONSTANT = {
  HOURS24: "24 hr policy",
  HOURS48: "48 hr policy",
  NONREFUNDABLE: "Non-refundable",
  FREECANCELLATION: "Free cancellation",
  GROUPCANCELLATION: "Group cancellation",
  SEVENDAY: "07 day policy",
  FOURTEENDAY: "14 day policy",
};
